// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Tooltip, Toastr, Button, Label, Input } from "../../../revvComponents";

// Components Imports
import { CustomSelect } from "../../../commonComponents";

// Actions Imports
import { WorkFlowActions } from "../../../actions";

// Destructuring
const { updateWorkFlowData } = WorkFlowActions;

class WFActions extends Component {
  _updateState = newState => {
    this.props.updateWorkFlowData("action", newState, this.props.index);
  };

  _onAddApprover = () => {
    const cloneState = Object.assign({}, this.props.data);
    let isNotEmpty = true;

    // CHECK IF THE LAST APPROVER VALUES IS NOT EMPTY
    if (cloneState.approvers.length > 0) {
      const lastRowIndex = cloneState.approvers.length - 1;
      const tempArray = Object.values(cloneState.approvers[lastRowIndex]);
      if (tempArray.length === 0) {
        isNotEmpty = false;
      } else {
        isNotEmpty = tempArray.every(value => value !== "");
      }
    }

    // ACTIONS BASED ON ABOVE CONDITION
    if (isNotEmpty) {
      cloneState.approvers.push({ id: "", name: "", label: "" });
      this._updateState(cloneState);
    } else {
      Toastr.showToastr({
        type: "warning",
        message: "Kindly add an approver",
        timeout: 3000,
      });
    }
  };

  _onRemoveApprover = index => {
    const cloneState = Object.assign({}, this.props.data);
    cloneState.approvers.splice(index, 1);
    this._updateState(cloneState);
  };

  _onInputChange = (field, event) => {
    this._updateState({ [field]: event.target.value });
  };

  // _onNumberInputChange = (field, value) => {
  //   this._updateState({ [field]: value });
  // };

  _onSelectChange = (field, value, index) => {
    if (index !== undefined) {
      const cloneState = Object.assign({}, this.props.data);
      cloneState.approvers[index] = value;
      this._updateState(cloneState);
    } else {
      this._updateState({ [field]: value });
    }
  };

  // FILTER ALREADY ADDED APPROVER FROM THE DROPDOWN OPTION
  _filterSelectedApprover = () => {
    const { approversOptions, data } = this.props;
    const { approvers } = data;

    const approversList = approvers.map(
      approver => approver.name || approver.value,
    );

    return approversOptions.map(approver => {
      const unusedApprovers = approver.options.filter(
        user => !approversList.includes(user.name || user.value),
      );
      approver.options = unusedApprovers;
      return approver;
    });
  };

  render() {
    const { condition, data } = this.props;
    const { approvers = [], approvalType = "", triggerMessage = "" } = data;

    const formatGroupLabel = approver => (
      <div>
        <span>{approver.label}</span>
      </div>
    );

    return (
      <div className="wfactions-wrapper">
        <div className="wfactions-title-section">
          <div className="wfactions-icon">
            <FontAwesomeIcon icon={["fas", "magic"]} />
          </div>
          <div className="wfactions-info">
            <div className="wfactions-title">Actions</div>
            <div className="wfactions-subtitle">
              Select or add actions to happen when conditions are met
            </div>
          </div>
        </div>
        {!condition.conditions.length > 0 && (
          <Fragment>
            <div className="wfactions-empty-section">
              <div className="wfactions-empty-info">
                Your workflow doesn&apos;t have an action yet. Select an action
                from below
              </div>
            </div>
            <div className="wfactions-approval-section">
              <div className="wfconditions-section-title">
                Suggested Actions
              </div>
              <div className="wfactions-approval-wrapper">
                <div className="wfactions-approval-title">
                  <span className="wfactions-expand-ico">
                    <FontAwesomeIcon icon={["far", "plus"]} />
                  </span>
                  <span> This will require approval</span>
                </div>
              </div>
            </div>
          </Fragment>
        )}

        {condition.conditions.length > 0 && (
          <div className="wfactions-approval-sectionselected">
            <div>
              <div className="wfactions-approval-titleselected">
                <span className="wfactions-tick-ico">
                  <FontAwesomeIcon icon={["far", "check"]} />
                </span>
                <span className="wfconditions-title-txt">
                  {" "}
                  This will require approval
                </span>
              </div>
              <div className="wfactions-approval-body">
                <div className="wfactions-approvers-list">
                  <div className="wfactions-approvers-type">
                    <span className="wfactions-approvers-option">
                      <Label>
                        <Input
                          type="radio"
                          name="choose_source"
                          value
                          checked={approvalType === "Sequential"}
                          onChange={() =>
                            this._onSelectChange("approvalType", "Sequential")
                          }
                          data-test="wfactions-sequential-approval-input"
                        />
                        Sequential Approval
                      </Label>
                    </span>
                    <span className="wfactions-approvers-option">
                      <Label>
                        <Input
                          type="radio"
                          name="choose_source"
                          value
                          checked={approvalType === "Parallel"}
                          onChange={() =>
                            this._onSelectChange("approvalType", "Parallel")
                          }
                          data-test="wfactions-parallel-approval-input"
                        />
                        Parallel Approval
                      </Label>
                    </span>
                  </div>
                  <span className="wfactions-approvers-title">
                    Approvers and in their order of approval
                  </span>
                  {approvers.map((user, index) => (
                    <div
                      className="wfactions-approvers-wrapper"
                      key={`${user.type}_${user.id}`}>
                      <CustomSelect
                        className="wfactions-approvers-listitems"
                        isSearchable
                        options={this._filterSelectedApprover()}
                        formatGroupLabel={formatGroupLabel}
                        value={user}
                        onChange={value =>
                          this._onSelectChange("approvers", value, index)
                        }
                        data-test="wfactions-custom-select"
                      />
                      <span
                        className="wfactions-approvers-removeico"
                        tabIndex="0"
                        role="button"
                        onKeyPress={() => this._onRemoveApprover(index)}
                        onClick={() => this._onRemoveApprover(index)}>
                        <Tooltip placement="top" overlay="Remove Approver">
                          <FontAwesomeIcon icon={["far", "times-circle"]} />
                        </Tooltip>
                      </span>
                    </div>
                  ))}
                </div>
                <div className="wfactions-add-wrapper">
                  <Button
                    type="two"
                    onClick={this._onAddApprover}
                    onKeyPress={this._onAddApprover}
                    role="button"
                    tabIndex="0"
                    data-test="wfactions-add-approver-btn">
                    <i>
                      <FontAwesomeIcon icon={["far", "plus"]} />
                    </i>
                    Add another Approver
                  </Button>
                  <div className="wfactions-trigger-msg">
                    <span className="wfconditionslist-label">
                      Message displayed on approval trigger
                    </span>
                    <Input
                      placeholder="Enter Message"
                      value={triggerMessage}
                      onChange={event =>
                        this._onInputChange("triggerMessage", event)
                      }
                      data-test="wfactions-trigger-msg-input"
                    />
                  </div>
                  {/* NEED THIS FOR LATER ITRATIONS */}
                  {/* <div className="wfactions-approval-email-section">
                    <div>Email Subject Line to Approvers</div>
                    <div className="wfactions-approval-emailsub">
                      <Input
                        placeholder="[Approval Request] from {deal_owner_name} for {document_name}"
                        value={emailSub}
                        disabled
                        onChange={event => this._onInputChange("emailSub", event)}
                      />
                    </div>
                  </div> */}

                  {/* <div className="wfactions-approval-email-section wfactions-approval-emailsec-borderbottom">
                    <div>Email Content</div>
                    <textarea
                      className="wfactions-approval-email"
                      placeholder=""
                      rows="10"
                      value={emailMsg}
                      onChange={event => this._onInputChange("emailMsg", event)}
                    />
                  </div> */}

                  {/* <div className="wfactions-approval-email-section">
                    <div>Email Subject Line after approve/reject</div>
                    <div className="wfactions-approval-emailsub">
                      <Input
                        placeholder="Your {document_name} has been {approval_status} by {approver_name} "
                        value={replySub}
                        disabled
                        onChange={event => this._onInputChange("replySub", event)}
                      />
                    </div>
                  </div> */}

                  {/* <div className="wfactions-approval-email-section">
                    <div>Email Content</div>
                    <textarea
                      className="wfactions-approval-email"
                      placeholder=""
                      rows="10"
                      value={replyMsg}
                      onChange={event => this._onInputChange("replyMsg", event)}
                    />
                  </div> */}

                  {/* NEED THIS FOR LATER ITRATIONS */}
                  {/* <div>
                    <div className="wfactions-approval-title">
                      Add followers (Followers will receive email notification)
                    </div>
                    <ReactSelect
                      isMulti
                      isSearchable
                      valueKey="name"
                      options={users}
                      value={followers}
                      onChange={event => this._onSelectChange("followers", event)}
                    />
                    <textarea
                      placeholder=""
                      rows="6"
                      value={followersMsg}
                      onChange={event => this._onInputChange("followersMsg", event)}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    users,
    userGroups,
    workflowDetails: { rule: { actions = {} } = {} },
  } = state.WorkFlowStore;

  // filter the active users only
  let activeUsers = [];
  if (users && users.length > 0) {
    activeUsers = users.filter(user => user.is_active);
  }
  //* Generate Approvers option containing both user & group data
  const userOptions = activeUsers.map(user => ({
    id: user.id,
    value: user.name,
    label: user.name,
    type: "user",
  }));

  // filter the active groups only
  let activeGroups = [];
  if (userGroups && userGroups.length > 0) {
    activeGroups = userGroups.filter(userGroup => userGroup.active);
  }

  const userGroupOptions = activeGroups.map(user => ({
    id: user.id,
    value: user.name,
    label: user.name,
    type: "group",
  }));

  const approversOptions = [
    {
      label: "Teammates",
      options: userOptions,
    },
    {
      label: "Groups",
      options: userGroupOptions,
    },
  ];
  return {
    approversOptions,
    actions,
  };
};

const mapDispatchToProps = {
  updateWorkFlowData,
};

export default connect(mapStateToProps, mapDispatchToProps)(WFActions);
